export const MAX_CHARS_PER_COMMENT = 150;

export const AVATAR_IMAGES = [
  "https://res.cloudinary.com/compara/image/upload/v1575387157/users/avatars/avatar1.svg",
  "https://res.cloudinary.com/compara/image/upload/v1575387156/users/avatars/avatar2.svg",
  "https://res.cloudinary.com/compara/image/upload/v1575387157/users/avatars/avatar3.svg",
  "https://res.cloudinary.com/compara/image/upload/v1575387157/users/avatars/avatar4.svg",
  "https://res.cloudinary.com/compara/image/upload/v1575387157/users/avatars/avatar5.svg",
  "https://res.cloudinary.com/compara/image/upload/v1575387157/users/avatars/avatar6.svg",
  "https://res.cloudinary.com/compara/image/upload/v1575387158/users/avatars/avatar7.svg"
];

export const DATE_FORMAT = {
  day: "numeric",
  month: "long",
  year: "numeric"
};
